/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UserAreaRouteImport } from './routes/user-area'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as AssignmentsRouteImport } from './routes/assignments'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UpdatesIndexRouteImport } from './routes/updates/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as UpdatesSlugRouteImport } from './routes/updates/$slug'
import { Route as PartnerSettingsRouteImport } from './routes/partner/settings'
import { Route as PartnerDashboardRouteImport } from './routes/partner/dashboard'
import { Route as ChallengesCompletedRouteImport } from './routes/challenges/completed'
import { Route as ChallengesAvailableRouteImport } from './routes/challenges/available'
import { Route as ChallengeSlugRouteImport } from './routes/challenge.$slug'
import { Route as AuthLinkedinRouteImport } from './routes/auth/linkedin'
import { Route as AuthGoogleRouteImport } from './routes/auth/google'
import { Route as AdminWaitingListRouteImport } from './routes/admin/waiting-list'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTasksRouteImport } from './routes/admin/tasks'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminInvitationsRouteImport } from './routes/admin/invitations'
import { Route as AdminChallengesRouteImport } from './routes/admin/challenges'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as PartnerCIdRouteImport } from './routes/partner/c.$id'
import { Route as AdminOrganizationsAssignmentsOrganizationIdRouteImport } from './routes/admin/organizations/assignments.$organizationId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const UserAreaRoute = UserAreaRouteImport.update({
  id: '/user-area',
  path: '/user-area',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsRoute = AssignmentsRouteImport.update({
  id: '/assignments',
  path: '/assignments',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpdatesIndexRoute = UpdatesIndexRouteImport.update({
  id: '/updates/',
  path: '/updates/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const UpdatesSlugRoute = UpdatesSlugRouteImport.update({
  id: '/updates/$slug',
  path: '/updates/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerSettingsRoute = PartnerSettingsRouteImport.update({
  id: '/partner/settings',
  path: '/partner/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerDashboardRoute = PartnerDashboardRouteImport.update({
  id: '/partner/dashboard',
  path: '/partner/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengesCompletedRoute = ChallengesCompletedRouteImport.update({
  id: '/challenges/completed',
  path: '/challenges/completed',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengesAvailableRoute = ChallengesAvailableRouteImport.update({
  id: '/challenges/available',
  path: '/challenges/available',
  getParentRoute: () => rootRouteImport,
} as any)
const ChallengeSlugRoute = ChallengeSlugRouteImport.update({
  id: '/challenge/$slug',
  path: '/challenge/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkedinRoute = AuthLinkedinRouteImport.update({
  id: '/auth/linkedin',
  path: '/auth/linkedin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGoogleRoute = AuthGoogleRouteImport.update({
  id: '/auth/google',
  path: '/auth/google',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWaitingListRoute = AdminWaitingListRouteImport.update({
  id: '/waiting-list',
  path: '/waiting-list',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTasksRoute = AdminTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvitationsRoute = AdminInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChallengesRoute = AdminChallengesRouteImport.update({
  id: '/challenges',
  path: '/challenges',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/organizations/',
  path: '/organizations/',
  getParentRoute: () => AdminRoute,
} as any)
const PartnerCIdRoute = PartnerCIdRouteImport.update({
  id: '/partner/c/$id',
  path: '/partner/c/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsAssignmentsOrganizationIdRoute =
  AdminOrganizationsAssignmentsOrganizationIdRouteImport.update({
    id: '/organizations/assignments/$organizationId',
    path: '/organizations/assignments/$organizationId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/challenges': typeof AdminChallengesRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/updates': typeof UpdatesIndexRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/challenges': typeof AdminChallengesRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/admin': typeof AdminIndexRoute
  '/updates': typeof UpdatesIndexRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/assignments': typeof AssignmentsRoute
  '/faq': typeof FaqRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/user-area': typeof UserAreaRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin/challenges': typeof AdminChallengesRoute
  '/admin/invitations': typeof AdminInvitationsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/tasks': typeof AdminTasksRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/waiting-list': typeof AdminWaitingListRoute
  '/auth/google': typeof AuthGoogleRoute
  '/auth/linkedin': typeof AuthLinkedinRoute
  '/challenge/$slug': typeof ChallengeSlugRoute
  '/challenges/available': typeof ChallengesAvailableRoute
  '/challenges/completed': typeof ChallengesCompletedRoute
  '/partner/dashboard': typeof PartnerDashboardRoute
  '/partner/settings': typeof PartnerSettingsRoute
  '/updates/$slug': typeof UpdatesSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/updates/': typeof UpdatesIndexRoute
  '/partner/c/$id': typeof PartnerCIdRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/organizations/assignments/$organizationId': typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/assignments'
    | '/faq'
    | '/privacy-policy'
    | '/reset-password'
    | '/terms-of-service'
    | '/user-area'
    | '/verify-email'
    | '/admin/challenges'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/tasks'
    | '/admin/users'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/linkedin'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/updates/$slug'
    | '/admin/'
    | '/updates'
    | '/partner/c/$id'
    | '/admin/organizations'
    | '/admin/organizations/assignments/$organizationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/assignments'
    | '/faq'
    | '/privacy-policy'
    | '/reset-password'
    | '/terms-of-service'
    | '/user-area'
    | '/verify-email'
    | '/admin/challenges'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/tasks'
    | '/admin/users'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/linkedin'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/updates/$slug'
    | '/admin'
    | '/updates'
    | '/partner/c/$id'
    | '/admin/organizations'
    | '/admin/organizations/assignments/$organizationId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/assignments'
    | '/faq'
    | '/privacy-policy'
    | '/reset-password'
    | '/terms-of-service'
    | '/user-area'
    | '/verify-email'
    | '/admin/challenges'
    | '/admin/invitations'
    | '/admin/settings'
    | '/admin/tasks'
    | '/admin/users'
    | '/admin/waiting-list'
    | '/auth/google'
    | '/auth/linkedin'
    | '/challenge/$slug'
    | '/challenges/available'
    | '/challenges/completed'
    | '/partner/dashboard'
    | '/partner/settings'
    | '/updates/$slug'
    | '/admin/'
    | '/updates/'
    | '/partner/c/$id'
    | '/admin/organizations/'
    | '/admin/organizations/assignments/$organizationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
  AssignmentsRoute: typeof AssignmentsRoute
  FaqRoute: typeof FaqRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  UserAreaRoute: typeof UserAreaRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthGoogleRoute: typeof AuthGoogleRoute
  AuthLinkedinRoute: typeof AuthLinkedinRoute
  ChallengeSlugRoute: typeof ChallengeSlugRoute
  ChallengesAvailableRoute: typeof ChallengesAvailableRoute
  ChallengesCompletedRoute: typeof ChallengesCompletedRoute
  PartnerDashboardRoute: typeof PartnerDashboardRoute
  PartnerSettingsRoute: typeof PartnerSettingsRoute
  UpdatesSlugRoute: typeof UpdatesSlugRoute
  UpdatesIndexRoute: typeof UpdatesIndexRoute
  PartnerCIdRoute: typeof PartnerCIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user-area': {
      id: '/user-area'
      path: '/user-area'
      fullPath: '/user-area'
      preLoaderRoute: typeof UserAreaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments': {
      id: '/assignments'
      path: '/assignments'
      fullPath: '/assignments'
      preLoaderRoute: typeof AssignmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/updates/': {
      id: '/updates/'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof UpdatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/updates/$slug': {
      id: '/updates/$slug'
      path: '/updates/$slug'
      fullPath: '/updates/$slug'
      preLoaderRoute: typeof UpdatesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/settings': {
      id: '/partner/settings'
      path: '/partner/settings'
      fullPath: '/partner/settings'
      preLoaderRoute: typeof PartnerSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/dashboard': {
      id: '/partner/dashboard'
      path: '/partner/dashboard'
      fullPath: '/partner/dashboard'
      preLoaderRoute: typeof PartnerDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/completed': {
      id: '/challenges/completed'
      path: '/challenges/completed'
      fullPath: '/challenges/completed'
      preLoaderRoute: typeof ChallengesCompletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenges/available': {
      id: '/challenges/available'
      path: '/challenges/available'
      fullPath: '/challenges/available'
      preLoaderRoute: typeof ChallengesAvailableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/challenge/$slug': {
      id: '/challenge/$slug'
      path: '/challenge/$slug'
      fullPath: '/challenge/$slug'
      preLoaderRoute: typeof ChallengeSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/linkedin': {
      id: '/auth/linkedin'
      path: '/auth/linkedin'
      fullPath: '/auth/linkedin'
      preLoaderRoute: typeof AuthLinkedinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google': {
      id: '/auth/google'
      path: '/auth/google'
      fullPath: '/auth/google'
      preLoaderRoute: typeof AuthGoogleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/waiting-list': {
      id: '/admin/waiting-list'
      path: '/waiting-list'
      fullPath: '/admin/waiting-list'
      preLoaderRoute: typeof AdminWaitingListRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tasks': {
      id: '/admin/tasks'
      path: '/tasks'
      fullPath: '/admin/tasks'
      preLoaderRoute: typeof AdminTasksRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invitations': {
      id: '/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AdminInvitationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/challenges': {
      id: '/admin/challenges'
      path: '/challenges'
      fullPath: '/admin/challenges'
      preLoaderRoute: typeof AdminChallengesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/partner/c/$id': {
      id: '/partner/c/$id'
      path: '/partner/c/$id'
      fullPath: '/partner/c/$id'
      preLoaderRoute: typeof PartnerCIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/assignments/$organizationId': {
      id: '/admin/organizations/assignments/$organizationId'
      path: '/organizations/assignments/$organizationId'
      fullPath: '/admin/organizations/assignments/$organizationId'
      preLoaderRoute: typeof AdminOrganizationsAssignmentsOrganizationIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminChallengesRoute: typeof AdminChallengesRoute
  AdminInvitationsRoute: typeof AdminInvitationsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminTasksRoute: typeof AdminTasksRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminWaitingListRoute: typeof AdminWaitingListRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminOrganizationsAssignmentsOrganizationIdRoute: typeof AdminOrganizationsAssignmentsOrganizationIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminChallengesRoute: AdminChallengesRoute,
  AdminInvitationsRoute: AdminInvitationsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminTasksRoute: AdminTasksRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminWaitingListRoute: AdminWaitingListRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminOrganizationsAssignmentsOrganizationIdRoute:
    AdminOrganizationsAssignmentsOrganizationIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
  AssignmentsRoute: AssignmentsRoute,
  FaqRoute: FaqRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  UserAreaRoute: UserAreaRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthGoogleRoute: AuthGoogleRoute,
  AuthLinkedinRoute: AuthLinkedinRoute,
  ChallengeSlugRoute: ChallengeSlugRoute,
  ChallengesAvailableRoute: ChallengesAvailableRoute,
  ChallengesCompletedRoute: ChallengesCompletedRoute,
  PartnerDashboardRoute: PartnerDashboardRoute,
  PartnerSettingsRoute: PartnerSettingsRoute,
  UpdatesSlugRoute: UpdatesSlugRoute,
  UpdatesIndexRoute: UpdatesIndexRoute,
  PartnerCIdRoute: PartnerCIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
